import Swal from "sweetalert2";
import Axios from "./axios";
import {
  BANNER,
  BANNERADD,
  BANNERDELETE,
  CATALOGPRODUCTCLONE,
  CATALOGPRODUCTCLONELIST,
  CREATECATALOGDELETE,
  CREATECATALOGDRAFT,
  CREATECATALOGGET,
  CREATECATALOGPRODUCT,
  CREATECATALOGUPDATE,
  DASHBOARD,
  DELETECATALOGIMAGE,
  GET_REFUNDS_SUCCESS,
  ON_ORDER_DETAILS,
  ONADMINDETAIL,
  ONADMINLOGIN,
  ONALLADMIN,
  ONALLORDERS,
  ONALLPRODUCTS,
  ONALLROLE,
  ONCATALOGLIST,
  ONCATALOGSUBMIT,
  ONCATALOGVIEW,
  ONCATEGORIES,
  ONCATEGORIESADD,
  ONCATEGORIESDELETE,
  ONCATEGORIESEDIT,
  ONCATEGORIESLIST,
  ONCREATEADMIN,
  ONCREATEROLE,
  ONCREATESHIPMENT,
  ONCREATESHIPMENTLABEL,
  ONDELETEADMIN,
  ONDELETEROLE,
  ONDOWNLOADLABEL,
  ONEDITADMIN,
  ONEDITROLE,
  ONLIVECATALOGPRODUCT,
  ONOFFERS,
  ONOFFERSADD,
  ONOFFERSDELETE,
  ONOFFERSEDIT,
  ONPRODUCTADD,
  ONPRODUCTDELET,
  ONPRODUCTEDIT,
  ONPRODUCTS,
  ONPRODUCTVIEW,
  ONSENDNOTIFICATION,
  ONSIZEGUIDE,
  ONSIZEGUIDEADD,
  ONSIZEGUIDEDELETE,
  ONSIZEGUIDEEDIT,
  ONUSERS,
  REFUND_PROCESSING,
  REFUND_SUCCESS,
  UPLOADCATALOGIMAGE,
} from "./type";

const config = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
  },
};

Axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const handleError = (err, setMessage, setShowError) => {
  if (err?.response?.status === 401) {
    localStorage.removeItem("adminToken");
    // window.location.reload();
  } else if ([400, 429].includes(err?.response?.status)) {
  }
};

export const onUsers = (setLoading, page, limit) => async (dispatch) => {
  try {
    const res = await Axios.get(
      `/total-users?page=${page + 1}&limit=${limit}`,
      config,
    );
    dispatch({ type: ONUSERS, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onProducts =
  (setLoading, page, limit, search = "") =>
  async (dispatch) => {
    try {
      const query = new URLSearchParams({ page, limit });
      if (search) query.append("search", search);
      const res = await Axios.get(`/products/all?${query.toString()}`, config);
      dispatch({ type: ONPRODUCTS, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onAllProducts = (setProduts) => async (dispatch) => {
  try {
    const res = await Axios.get(`/products/all-products`, config);
    const options = res.data.map((p) => ({
      value: p._id,
      label: p.name,
    }));
    setProduts(options);
    dispatch({ type: ONALLPRODUCTS, payload: res.data });
  } catch (err) {
    handleError(err);
  }
};

export const onProductView =
  (setLoading, productId, setProduct) => async (dispatch) => {
    try {
      const res = await Axios.get(`/products/find/${productId}`, config);
      setProduct(res.data);
      dispatch({ type: ONPRODUCTVIEW, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onProductEdit =
  (setLoading, productId, formData, navigate) => async (dispatch) => {
    try {
      const res = await Axios.put(`/products/${productId}`, formData, config);
      if (res.data.success === true) {
        alert("✅ Product updated successfully!");
        navigate("/products");
      } else {
        alert(res.data.message);
      }
      dispatch({ type: ONPRODUCTEDIT, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onProductAdd =
  (setLoading, formData, navigate) => async (dispatch) => {
    try {
      const res = await Axios.post(`/products`, formData, config);
      if (res.data.success === true) {
        alert("✅ Product added successfully!");
        navigate("/products");
      } else {
        alert(res.data.message);
      }
      dispatch({ type: ONPRODUCTADD, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onProductDelete = (setLoading, productId) => async (dispatch) => {
  try {
    const res = await Axios.delete(`/products/${productId}`, config);
    if (res.data.success === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONPRODUCTDELET, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onCategories = (setLoading, setCategories) => async (dispatch) => {
  try {
    const res = await Axios.get(`/categories/tree`, config);
    setCategories(res.data);
    dispatch({ type: ONCATEGORIES, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onCategoriesList = (setCategories) => async (dispatch) => {
  try {
    const res = await Axios.get(`/categories`, config);
    const options = res.data.map((p) => ({
      value: p._id,
      label: p.name,
    }));
    setCategories(options);
    dispatch({ type: ONCATEGORIESLIST, payload: res.data });
  } catch (err) {
    handleError(err);
  }
};

export const onCategoriesDelete =
  (setLoading, categoriesId) => async (dispatch) => {
    try {
      const res = await Axios.delete(`/categories/${categoriesId}`, config);
      if (res.data.success === true) {
        alert(res.data.message);
      } else {
        alert(res.data.message);
      }
      dispatch({ type: ONCATEGORIESDELETE, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onCategoriesAdd =
  (setLoading, data, setShowModal) => async (dispatch) => {
    try {
      const res = await Axios.post(`/categories`, data, config);
      if (res.data.status === true) {
        alert(res.data.message);
        setShowModal(false);
      } else {
        alert(res.data.message);
      }
      dispatch({ type: ONCATEGORIESADD, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onCategoriesEdit =
  (setLoading, data, id, setShowModal) => async (dispatch) => {
    try {
      const res = await Axios.put(`/categories/${id}`, data, config);
      if (res.data.status === true) {
        alert(res.data.message);
        setShowModal(false);
      } else {
        alert(res.data.message);
      }
      dispatch({ type: ONCATEGORIESEDIT, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onSizeGuide =
  (setLoading, setGuides, setError) => async (dispatch) => {
    try {
      const res = await Axios.get(`/sizeguides`, config);
      setGuides(res.data);
      dispatch({ type: ONSIZEGUIDE, payload: res.data });
      setLoading(false);
    } catch (err) {
      setError("Could not load size guides.");
      handleError(err);
    }
  };

export const onSizeGuideAdd = (setLoading, data) => async (dispatch) => {
  try {
    const res = await Axios.post(`/sizeguides`, data, config);
    if (res.data.success === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONSIZEGUIDEADD, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onSizeGuideEdit = (setLoading, data, id) => async (dispatch) => {
  try {
    const res = await Axios.put(`/sizeguides/${id}`, data, config);
    if (res.data.success === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONSIZEGUIDEEDIT, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onSizeGuideDelete = (setLoading, id) => async (dispatch) => {
  try {
    const res = await Axios.delete(`/sizeguides/${id}`, config);
    if (res.data.success === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONSIZEGUIDEDELETE, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onOfers = (setLoading) => async (dispatch) => {
  try {
    setLoading(true);
    const res = await Axios.get(`/offer`, config);
    dispatch({ type: ONOFFERS, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onOfersAdd = (setLoading, data, navigate) => async (dispatch) => {
  try {
    const res = await Axios.post(`/offer`, data, config);
    if (res.data.success === true) {
      navigate("/offers");
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONOFFERSADD, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onOfersEdit =
  (setLoading, data, id, navigate) => async (dispatch) => {
    try {
      const res = await Axios.put(`/offer/${id}`, data, config);
      if (res.data.success === true) {
        navigate("/offers");
        alert(res.data.message);
      } else {
        alert(res.data.message);
      }
      dispatch({ type: ONOFFERSEDIT, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onOffersDelete = (setLoading, id) => async (dispatch) => {
  try {
    setLoading(true);
    const res = await Axios.delete(`/offer/${id}`, config);
    if (res.data.success === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONOFFERSDELETE, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onAllOders =
  (setLoading, setOrders, page, limit, status = "all") =>
  async (dispatch) => {
    try {
      setLoading(true);
      const res = await Axios.get(
        `/admin/all-orders?page=${page}&limit=${limit}&status=${status}`,
        config,
      );
      setOrders(res.data);
      dispatch({ type: ONALLORDERS, payload: res.data });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      handleError(err);
    }
  };

export const onCreateRole = (setLoading, data) => async (dispatch) => {
  try {
    const res = await Axios.post(`/role`, data, config);
    if (res.data.success === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONCREATEROLE, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onCreateShipment =
  (shipData, order, setIsShipping, navigate, Swal) => async (dispatch) => {
    try {
      const res = await Axios.post(
        `/admin/approve-order/${order._id}`,
        shipData,
        config,
      );
      if (res.data.success) {
        Swal.fire(
          "Shipment Generated!",
          res.data.message || `AWB Code: ${res.data.data.awbCode}`,
          "success",
        );
        navigate(-1);
      } else {
        alert(res.data.message);
      }
      dispatch({ type: ONCREATESHIPMENT, payload: res.data });
      setIsShipping(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onCreateShipmentLabel =
  (orderId, Swal, fetchOrders) => async (dispatch) => {
    try {
      const res = await Axios.put(`/admin/order/cancel/${orderId}`, config);
      if (res.data.success) {
        Swal.fire("Success", "Order workflow terminated.", "success");
        fetchOrders();
      } else {
        alert(res.data.message);
      }
      dispatch({ type: ONCREATESHIPMENTLABEL, payload: res.data });
    } catch (err) {
      handleError(err);
    }
  };

export const onEditRole = (setLoading, data, id) => async (dispatch) => {
  try {
    const res = await Axios.put(`/role/${id}`, data, config);
    if (res.data.success === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONEDITROLE, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onDeleteRole = (setLoading, id) => async (dispatch) => {
  try {
    const res = await Axios.delete(`/role/${id}`, config);
    if (res.data.success === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }
    dispatch({ type: ONDELETEROLE, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onAllRole = (setLoading, setRoles) => async (dispatch) => {
  try {
    const res = await Axios.get(`/role`, config);
    setRoles(res.data);
    dispatch({ type: ONALLROLE, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onAdminLogin =
  (setLoading, setError, data, navigate) => async (dispatch) => {
    try {
      const res = await Axios.post(`/admin-login`, data);
      if (res.data.status === true) {
        alert(res.data.message);
        localStorage.setItem("adminToken", res.data.token);
        navigate("/");
        window.location.reload();
      } else {
        setError(res.data.message);
        alert(res.data.message);
      }

      dispatch({ type: ONADMINLOGIN, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onAllAdmin = (setLoading, setUsers) => async (dispatch) => {
  try {
    const res = await Axios.get(`/all-admins`, config);
    setUsers(res.data);
    dispatch({ type: ONALLADMIN, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onCreateAdmin =
  (setLoading, data, setMessage) => async (dispatch) => {
    try {
      const res = await Axios.post(`/create-admin`, data, config);
      if (res.data.status === true) {
        setMessage(res.data.message);
        alert(res.data.message);
      } else {
        setMessage(res.data.message);
        alert(res.data.message);
      }

      dispatch({ type: ONCREATEADMIN, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onEditAdmin =
  (setLoading, data, id, setMessage) => async (dispatch) => {
    try {
      const res = await Axios.put(`/admin-update/${id}`, data, config);
      if (res.data.status === true) {
        setMessage(res.data.message);
        alert(res.data.message);
      } else {
        setMessage(res.data.message);
        alert(res.data.message);
      }

      dispatch({ type: ONEDITADMIN, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onDeleteAdmin = (setLoading, id) => async (dispatch) => {
  try {
    const res = await Axios.delete(`/admin-delete/${id}`, config);
    if (res.data.status === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }

    dispatch({ type: ONDELETEADMIN, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onAdminDetail = (setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const token = localStorage.getItem("adminToken"); // ✅ read at runtime
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const res = await Axios.get(`/admins-details`, config);
    dispatch({ type: ONADMINDETAIL, payload: res.data.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onSendNotification = (data, setLoading) => async (dispatch) => {
  try {
    const res = await Axios.post(`/send-notification`, data, config);
    if (res.data.status === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }

    dispatch({ type: ONSENDNOTIFICATION, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onDashboardData =
  (setLoading, selectedMonth, setDashboardData) => async (dispatch) => {
    setLoading(true);
    try {
      const res = await Axios.get(`/dashboard?month=${selectedMonth}`, config);
      setDashboardData(res.data);
      dispatch({ type: DASHBOARD, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onBanner = (setLoading) => async (dispatch) => {
  try {
    const res = await Axios.get(`/banner`, config);

    dispatch({ type: BANNER, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onBannerAdd = (data, setLoading, setShow) => async (dispatch) => {
  try {
    const res = await Axios.post(`/banner`, data, config);
    if (res.data.status === true) {
      setShow(false);
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }

    dispatch({ type: BANNERADD, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onBannerDelete = (id, setLoading) => async (dispatch) => {
  try {
    const res = await Axios.delete(`/banner/${id}`, config);
    if (res.data.status === true) {
      alert(res.data.message);
    } else {
      alert(res.data.message);
    }

    dispatch({ type: BANNERDELETE, payload: res.data });
    setLoading(false);
  } catch (err) {
    handleError(err);
  }
};

export const onCreateCatalogDraft =
  (formData, setLoading, navigate) => async (dispatch) => {
    try {
      setLoading(true);
      const res = await Axios.post(`/catalog-draft`, formData, config);

      if (res.data.success === true) {
        alert("Catalog Create Successfully");
        navigate(`/catalog/edit/${res.data.catalogId}`);
      } else {
        alert(res.data.message);
      }

      dispatch({ type: CREATECATALOGDRAFT, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onCreateCatalogGet =
  (catalogId, setLoading) => async (dispatch) => {
    try {
      setLoading(true);
      const res = await Axios.get(`/catalog-draft/${catalogId}`, config);

      dispatch({ type: CREATECATALOGGET, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onCreateCatalogUpdate =
  (catalogId, formData, setLoading) => async (dispatch) => {
    try {
      const res = await Axios.put(
        `/catalog-draft/${catalogId}`,
        formData,
        config,
      );

      if (res.data.status === true) {
        alert(res.data.message);
      } else {
        alert(res.data.message);
      }

      dispatch({ type: CREATECATALOGUPDATE, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onCatalogSubmit =
  (catalogId, setLoading, navigate) => async (dispatch) => {
    try {
      const res = await Axios.put(`/catalog-draft/${catalogId}/submit`, config);

      if (res.data.success === true) {
        alert(res.data.message);
        localStorage.removeItem(`catalog-products-${catalogId}`);
        navigate("/catalogs");
      } else {
        alert(res.data.message);
      }

      dispatch({ type: ONCATALOGSUBMIT, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onCreateCatalogDelete =
  (
    catalogId,
    productId,
    setLoading,
    setProducts,
    setActiveIndex,
    currentIndex,
    updated,
  ) =>
  async (dispatch) => {
    try {
      const res = await Axios.delete(
        `/catalog-draft/${catalogId}/product/${productId}`,
        config,
      );

      if (res.data.status === true) {
        alert(res.data.message);
        setProducts(updated);
        setActiveIndex(currentIndex);
      } else {
        alert(res.data.message);
      }

      dispatch({ type: CREATECATALOGDELETE, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };

export const onCreateCatalogProduct =
  (catalogId, formData, setLoading) => async (dispatch) => {
    try {
      const res = await Axios.post(
        `/catalog-draft/${catalogId}/product`,
        formData,
        config,
      );

      dispatch({ type: CREATECATALOGPRODUCT, payload: res.data });

      setLoading?.(false);

      return res; // important
    } catch (err) {
      setLoading?.(false);
      handleError(err);
      throw err;
    }
  };

export const onCatalogProductClone =
  (catalogId, setLoading) => async (dispatch) => {
    try {
      const res = await Axios.get(
        `/catalog-draft/clone-details/${catalogId}`,
        config,
      );

      dispatch({ type: CATALOGPRODUCTCLONE, payload: res.data });

      setLoading?.(false);

      return res; // important
    } catch (err) {
      setLoading?.(false);
      handleError(err);
      throw err;
    }
  };

export const onCatalogProductCloneList = (setLoading) => async (dispatch) => {
  try {
    const res = await Axios.get(`/catalog-draft/clone-list`, config);

    dispatch({ type: CATALOGPRODUCTCLONELIST, payload: res.data });

    setLoading?.(false);

    return res; // important
  } catch (err) {
    setLoading?.(false);
    handleError(err);
    throw err;
  }
};

export const onUploadCatalogImage =
  (formData, setLoading) => async (dispatch) => {
    try {
      setLoading(true);
      const res = await Axios.post(
        `/catalog-draft/upload-image`,
        formData,
        config,
      );

      dispatch({ type: UPLOADCATALOGIMAGE, payload: res.data });

      setLoading?.(false);

      return res; // important
    } catch (err) {
      setLoading?.(false);
      handleError(err);
      throw err;
    }
  };

export const onDeleteCatalogImage =
  (formData, setLoading) => async (dispatch) => {
    try {
      setLoading(true);

      const res = await Axios.delete(`/catalog-draft/delete-image`, {
        data: formData, // 👈 IMPORTANT FIX
        ...config,
      });

      dispatch({ type: DELETECATALOGIMAGE, payload: res.data });

      setLoading?.(false);

      return res; // important
    } catch (err) {
      setLoading?.(false);
      handleError(err);
      throw err;
    }
  };

export const onCatalogList =
  (page, limit, status, setLoading) => async (dispatch) => {
    try {
      setLoading(true);

      const res = await Axios.get(
        `/catalog-draft/draft-list?page=${page}&limit=${limit}&status=${status}`,
        {
          ...config,
        },
      );

      dispatch({ type: ONCATALOGLIST, payload: res.data });

      setLoading?.(false);

      return res; // important
    } catch (err) {
      setLoading?.(false);
      handleError(err);
      throw err;
    }
  };

export const onCatalogView = (id, setLoading) => async (dispatch) => {
  try {
    setLoading(true);

    const res = await Axios.get(`/catalog-draft/draft-view/${id}`, {
      ...config,
    });

    dispatch({ type: ONCATALOGVIEW, payload: res.data.data });

    setLoading?.(false);

    return res.data; // important
  } catch (err) {
    setLoading?.(false);
    handleError(err);
    throw err;
  }
};

export const onLiveCatalogProduct =
  (id, setLoading, navigate) => async (dispatch) => {
    try {
      const res = await Axios.get(
        `/catalog-draft/approve-catalog/${id}`,
        config,
      );

      if (res.data.success === true) {
        alert(res.data.message);
        navigate("/catalogs");
      } else {
        alert(res.data.message);
      }

      dispatch({ type: ONLIVECATALOGPRODUCT, payload: res.data });
      setLoading(false);
    } catch (err) {
      handleError(err);
    }
  };
export const onDownloadLabel =
  (orderId, orderDisplayId) => async (dispatch) => {
    try {
      console.log("ddjhjhd");
      Swal.fire({
        title: "Fetching Document...",
        text: "Streaming PDF from Shiprocket secure nodes.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      // Aapke Axios instance aur config ka use kiya taaki token pass ho sake
      const res = await Axios.get(`/admin/order/${orderId}/download-label`, {
        ...config,
        responseType: "blob", // Blob format zaroori hai PDF ke liye
      });

      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `label-${orderDisplayId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatch({ type: ONDOWNLOADLABEL, payload: res.data });
      Swal.close();
    } catch (err) {
      Swal.fire(
        "Label Error",
        err.response?.data?.message ||
          "Shipment routing not generated or API error.",
        "error",
      );
    }
  };

export const fetchSingleOrder =
  (id, setOrder, setLoading) => async (dispatch) => {
    try {
      setLoading(true);
      const res = await Axios.get(`/admin/order/${id}`, config);
      if (res.data.success) {
        setOrder(res.data.order);
        dispatch({ type: ON_ORDER_DETAILS, payload: res.data.order });
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      handleError(err);
    }
  };

// Fetch Pending Refunds Action
export const fetchPendingRefunds = () => async (dispatch) => {
  try {
    const res = await Axios.get(
      "/admin/refunds?status=refund_initiated",
      config,
    );
    if (res.data.success) {
      dispatch({ type: GET_REFUNDS_SUCCESS, payload: res.data.refunds });
    }
  } catch (err) {
    console.error("Error fetching refunds:", err);
  }
};

// Process Refund Action
export const processRefund = (transactionId, onSuccess) => async (dispatch) => {
  try {
    dispatch({ type: REFUND_PROCESSING, payload: transactionId });
    const res = await Axios.post(
      `/admin/refund/process/${transactionId}`,
      {},
      config,
    );

    if (res.data.success) {
      dispatch({ type: REFUND_SUCCESS, payload: transactionId });
      if (onSuccess)
        onSuccess(res.data.message || "Refund processed successfully!");
      dispatch(fetchPendingRefunds()); // Refresh list
    }
  } catch (err) {
    const errorMsg = err.response?.data?.message || "Failed to process refund";
    alert(errorMsg);
  } finally {
    dispatch({ type: REFUND_PROCESSING, payload: null });
  }
};
